import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row } from 'antd';
import Search from 'antd/es/input/Search';
import { SearchProps } from 'antd/lib/input';
import { useTranslation } from 'react-i18next';

interface CompanyFiltersProps {
  tableLoading: boolean;
  onSearch: (value: string) => void;
  onCreateCompany: () => void;
}

function CompanyFilters({
  tableLoading,
  onSearch,
  onCreateCompany,
}: CompanyFiltersProps) {
  const { t } = useTranslation();

  const handleSearch: SearchProps['onSearch'] = (value) => {
    onSearch(value);
  };

  return (
    <Card>
      <div className="filter-container">
        <Row gutter={[16, 12]} align="middle">
          <Col flex="none">
            <label className="filter-search-container">
              {t('scenes.settings.companies.scene.filters.label')}{' '}
              <Search
                placeholder={t(
                  'scenes.settings.companies.scene.filters.search_placeholder_name'
                )}
                onSearch={handleSearch}
                disabled={tableLoading}
                allowClear
              />
            </label>
          </Col>
          <Col flex="auto" />
          <Col flex="none" className="filter-buttons-container">
            <Button
              type="primary"
              onClick={onCreateCompany}
              disabled={tableLoading}
            >
              <PlusOutlined />{' '}
              {t('scenes.settings.companies.scene.buttons.create_company')}
            </Button>
          </Col>
        </Row>
      </div>
    </Card>
  );
}

export default CompanyFilters;
